// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"style-module--buttonWrapper--5c102"};